import { defineMessages } from 'react-intl';

export default defineMessages({
  copyright: {
    id: 'sentinel.components.appfooter.copyright',
    defaultMessage: 'Apex Clearing Corporation',
  },
  of: {
    id: 'sentinel.components.appfooter.of',
    defaultMessage: 'of',
  },
  resultsCount: {
    id: 'sentinel.components.appfooter.resultsCount',
    defaultMessage: 'Items',
  },
  resultsAmountTotal: {
    id: 'sentinel.components.appfooter.resultsAmountTotal',
    defaultMessage: 'Page Total',
  },
  registered: {
    id: 'sentinel.components.appfooter.registered',
    defaultMessage: 'FINRA BrokerCheck reports for Apex Clearing are available at:',
  },
  policy: {
    id: 'sentinel.components.appfooter.policy',
    defaultMessage: 'Privacy Policy',
  },
  other: {
    id: 'sentinel.components.appfooter.other',
    defaultMessage: 'Business Continuity Plan and Other Disclosures',
  },
  futures: {
    id: 'sentinel.components.appfooter.futures',
    defaultMessage: 'Futures Disclosures',
  },
  press: {
    id: 'sentinel.components.appfooter.press',
    defaultMessage: 'Press',
  },
  member: {
    id: 'sentinel.components.appfooter.member',
    defaultMessage: 'Member of FINRA, NYSE, SIPC.',
  },
});



// WEBPACK FOOTER //
// ./src/components/AppFooter/messages.js